const FreightDutyType = {
  FREIGHT_DATA: 'FREIGHT_DATA',
  DUTY_DATA: 'DUTY_DATA',
  FREIGHT_FILTER_VALUES: 'FREIGHT_FILTER_VALUES',
} as const;

export default FreightDutyType;
